import React, { useState, useEffect } from "react";
import styles from "./SuggestedPromptCards.module.css";
import "@flaticon/flaticon-uicons/css/all/all.css";

// Analytics
import { getAnalytics, logEvent } from "firebase/analytics";

const SuggestedPromptCards = ({ onPromptClick }) => {
  const analytics = getAnalytics();
  const prompts = [
    {
      text: [
        "Explain",
        " the fall of Rome from the perspective of a Roman soldier.",
      ],
      icon: "fi fi-bs-world",
    },
    {
      text: ["Tell me about", " a sheep that becomes the dictator of the CCP."],
      icon: "fi fi-br-scroll-document-story",
    },
  ];

  const [typedPrompts, setTypedPrompts] = useState(prompts.map(() => ""));
  const [isTypingComplete, setIsTypingComplete] = useState(
    prompts.map(() => false)
  );

  useEffect(() => {
    // console.log("prompts");
    prompts.forEach((prompt, index) => {
      let i = 0;
      const typingInterval = setInterval(() => {
        if (i <= prompt.text.join("").length) {
          setTypedPrompts((prev) => {
            const newTypedPrompts = [...prev];
            newTypedPrompts[index] = prompt.text.join("").slice(0, i);
            return newTypedPrompts;
          });
          i++;
        } else {
          clearInterval(typingInterval);
          setIsTypingComplete((prev) => {
            const newIsTypingComplete = [...prev];
            newIsTypingComplete[index] = true;
            return newIsTypingComplete;
          });
        }
      }, 30);

      return () => clearInterval(typingInterval);
    });
  }, []);

  return (
    <div className={styles.examples}>
      {prompts.map((prompt, index) => (
        <button
          key={index}
          className={styles["example-box"]}
          onClick={() => {
            onPromptClick(prompt.text.join(""));
            logEvent(analytics, `button_click_use_prompt`);
          }}
          aria-label={`Use prompt: ${prompt.text.join("")}`}
        >
          <p className={styles["example-text"]}>
            <span
              className={styles["typing-animation"]}
              style={{
                animation: isTypingComplete[index]
                  ? "none"
                  : `typing 2s steps(${prompt.text.join("").length}, end)`,
              }}
            >
              <strong>
                {typedPrompts[index].slice(0, prompt.text[0].length)}
              </strong>
              {typedPrompts[index].slice(prompt.text[0].length)}
            </span>
            <i className={prompt.icon}></i>
          </p>
          <svg
            className={styles["arrow-icon"]}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12 5L12 19M12 19L5 12M12 19L19 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ))}
    </div>
  );
};

export default SuggestedPromptCards;
